/**
 * Locations API
 * 
 * Handles location-related API calls.
 */

import api from './client';

export const locationsApi = {
  /**
   * Get all locations
   * @returns {Promise<Array>} List of locations
   */
  async getAll() {
    const response = await api.get('/api/locations');
    return response.data;
  },

  /**
   * Get all active zones (campuses)
   * @returns {Promise<Array>} List of zones
   */
  async getZones() {
    const response = await api.get('/api/zones');
    return response.data;
  },
};

export default locationsApi;
